import {
  BarcodeClientiTipo_AVI5,
  BarcodeClientiTipo_OLI6,
  CodicePersonalizzazione,
  BarcodeClientiTipo,
  Barcode12Atelier98,
  EAN13Atelier98,
  Barcode14Tipo,
  Barcode12Atelier98_No,
  Barcode12Atelier98_Si,
  Barcode12Atelier98_Siepuri,
  Barcode12Atelier98_Sweda,
  Barcode14Tipo_Mav,
  BarcodeClientiTipo_Cuf,
  BarcodeClientiTipo_Cuf911,
  BarcodeClientiTipo_In911,
  BarcodeClientiTipo_Mav,
  BarcodeClientiTipo_Tek,
  CodicePersonalizzazione_Fabi,
  CodicePersonalizzazione_Marilli,
  CodicePersonalizzazione_Scout,
  EAN13Atelier98_13come8,
  EAN13Atelier98_Siepuri,
  EAN13Atelier98_Nara,
  BarcodeGrigliaVentilazione,
  BarcodeGrigliaVentilazione_No,
  Barcode13Come12,
  Barcode13Come12_No,
} from '../Constants/Barcode'
import { TranslationKeys } from '../Constants/TranslationKeys'
import store from '../store'
import { renderTranslation } from './GenericHelpers'

export const HandleClientBarcode = (barcode, notify) => {
  const state = store.getState()
  const language = state.present.language.value

  if (barcode.substring(0, 2) === 'C|') {
    notify(renderTranslation(language, TranslationKeys.barcodeClientiError), true, false)
    return false
  }
  return true
}

export const Handle4CharacterBarcode = (barcode, search, notify) => {
  const state = store.getState()
  const language = state.present.language.value

  if (barcode.charAt(0) === 'N') {
    notify(renderTranslation(language, TranslationKeys.barcodeNegoziError), true, false)
    return
  }
  search(barcode)
}

export const Handle5CharacterBarcode = (barcode, search, notify) => {
  const state = store.getState()
  const configuration = state.present.configuration
  const language = state.present.language.value

  if (configuration[BarcodeClientiTipo] === BarcodeClientiTipo_AVI5) {
    notify(renderTranslation(language, TranslationKeys.barcodeClientiError), true, false)
    return
  }
  search(barcode)
}

export const Handle6CharacterBarcode = (barcode, search, notify) => {
  const state = store.getState()
  const configuration = state.present.configuration
  const language = state.present.language.value

  if (configuration[BarcodeClientiTipo] === BarcodeClientiTipo_OLI6) {
    notify(renderTranslation(language, TranslationKeys.barcodeClientiError), true, false)
    return
  }
  search(barcode)
}

export const Handle7CharacterBarcode = (barcode, search) => {
  search(barcode)
}

export const Handle8CharacterBarcode = (barcode, search, notify) => {
  const state = store.getState()
  const configuration = state.present.configuration
  const language = state.present.language.value

  if (configuration[CodicePersonalizzazione] === CodicePersonalizzazione_Scout) {
    if (barcode.charAt(0) === 'X') {
      notify(renderTranslation(language, TranslationKeys.barcodeBoxError), true, false)
      return
    }
    if (barcode.substring(0, 2) === 'BG') {
      notify(renderTranslation(language, TranslationKeys.barcodeAddettiError), true, false)
      return
    }
  }
  search(barcode)
}

export const Handle9CharacterBarcode = (barcode, search, notify) => {
  const state = store.getState()
  const configuration = state.present.configuration
  const language = state.present.language.value

  if (configuration[CodicePersonalizzazione] === CodicePersonalizzazione_Fabi) {
    if (barcode.substring(0, 3) === '000') {
      search('80' + barcode.slice(barcode.length - 6))
      return
    }
    if (barcode.substring(0, 2) === '09') {
      notify(renderTranslation(language, TranslationKeys.barcodeClientiError), true, false)
      return
    }
    search(barcode.substring(0, 8))
    return
  }
  if (configuration[BarcodeClientiTipo] === BarcodeClientiTipo_Tek) {
    notify(renderTranslation(language, TranslationKeys.barcodeClientiError), true, false)
    return
  }
  search(barcode)
}

export const Handle10CharacterBarcode = (barcode, search, notify) => {
  const state = store.getState()
  const configuration = state.present.configuration
  const language = state.present.language.value

  if (configuration[CodicePersonalizzazione] === CodicePersonalizzazione_Fabi) {
    if (barcode.substring(0, 3) === '000') {
      search('80' + barcode.slice(barcode.length - 6))
      return
    }
    if (barcode.substring(0, 2) === '09') {
      notify(renderTranslation(language, TranslationKeys.barcodeClientiError), true, false)
      return
    }
    search(barcode.substring(0, 8))
    return
  }
  if (configuration[CodicePersonalizzazione] === CodicePersonalizzazione_Scout) {
    notify(renderTranslation(language, TranslationKeys.barcodeBoxError), true, false)
    return
  }
  if (configuration[BarcodeClientiTipo] === BarcodeClientiTipo_Cuf && barcode.substring(0, 6) === '000000') {
    notify(renderTranslation(language, TranslationKeys.barcodeClientiError), true, false)
    return
  }
  search(barcode)
}

export const Handle11CharacterBarcode = (barcode, search, notify) => {
  const state = store.getState()
  const configuration = state.present.configuration
  const language = state.present.language.value

  if (barcode.charAt(0) === 'M' || barcode.charAt('0') === 'W') {
    notify(renderTranslation(language, TranslationKeys.barcodeNegoziError), true, false)
    return
  }
  if (barcode.substring(0, 2) === 'GC') {
    notify(renderTranslation(language, TranslationKeys.barcodeClientiError), true, false)
    return
  }
  if (configuration[CodicePersonalizzazione] === CodicePersonalizzazione_Fabi) {
    if (barcode.substring(0, 3) === '000') {
      search('80' + barcode.slice(barcode.length - 6))
      return
    }
  }
  if (barcode.charAt(0) === 'N') {
    search('-' + barcode.slice(barcode.length - 10))
    return
  }
  if (configuration[BarcodeClientiTipo] === BarcodeClientiTipo_Mav) {
    notify(renderTranslation(language, TranslationKeys.barcodeClientiError), true, false)
    return
  }
  search(barcode)
}

export const Handle12CharacterBarcode = (barcode, search, notify) => {
  const state = store.getState()
  const configuration = state.present.configuration
  const language = state.present.language.value

  if (barcode.substring(0, 2) === 'GC') {
    notify(renderTranslation(language, TranslationKeys.barcodeClientiError), true, false)
    return
  }
  if (configuration[Barcode12Atelier98] === Barcode12Atelier98_Si) {
    if (barcode.substring(0, 2) === '90') {
      search('-' + barcode.slice(barcode.length - 10))
      return
    }
    if (barcode.charAt(0) === '0') {
      search(barcode.slice(barcode.length - 11))
      return
    }
  }
  if (configuration[Barcode12Atelier98] === Barcode12Atelier98_No) {
    search(barcode)
    return
  }
  if (configuration[Barcode12Atelier98] === Barcode12Atelier98_Sweda) {
    if (barcode.charAt(0) === '9') {
      search('-' + barcode.substring(1, 11))
      return
    } else {
      search(barcode.substring(0, 11))
      return
    }
  }
  if (configuration[Barcode12Atelier98] === Barcode12Atelier98_Siepuri) {
    if (barcode.substring(0, 2) === '90') {
      search('-' + barcode.slice(barcode.length - 10))
      return
    }
    if (barcode.charAt(0) === '0') {
      search(barcode.slice(barcode.length - 11))
      return
    }
    //todo cercare conflitto ????
    search(barcode)
    return
  }
  if (configuration[EAN13Atelier98] === EAN13Atelier98_Nara) {
    search(barcode.substring(0, 2) + '99' + barcode.slice(barcode.length - 8))
    return
  }
  search(barcode)
}

export const Handle13CharacterBarcode = (barcode, search, notify, skipEAN13Atelier98 = false) => {
  const state = store.getState()
  const configuration = state.present.configuration
  const language = state.present.language.value

  if (configuration[EAN13Atelier98] === EAN13Atelier98_Siepuri && !skipEAN13Atelier98) {
    search(barcode, () => Handle13CharacterBarcode(barcode, search, notify, true))
    return
  }

  if (configuration[Barcode13Come12] !== Barcode13Come12_No) {
    Handle12CharacterBarcode(barcode.substring(0, 12), search, notify)
    return
  }
  if (configuration[EAN13Atelier98] === EAN13Atelier98_13come8) {
    search(barcode.substring(0, 8))
    return
  }
  if (configuration[BarcodeClientiTipo] === BarcodeClientiTipo_Cuf911 && barcode.substring(0, 6) === '911000') {
    notify(renderTranslation(language, TranslationKeys.barcodeClientiError), true, false)
    return
  }
  if (
    configuration[BarcodeClientiTipo] === BarcodeClientiTipo_In911 &&
    (barcode.substring(0, 4) === '2011' || barcode.substring(0, 4) === '2012')
  ) {
    notify(renderTranslation(language, TranslationKeys.barcodeClientiError), true, false)
    return
  }
  if (barcode.substring(0, 6) === '299999') {
    notify(renderTranslation(language, TranslationKeys.barcodeClientiError), true, false)
    return
  }

  const twoChar = barcode.substring(0, 2)
  switch (twoChar) {
    case '20':
      search(barcode.substring(1, 12))
      return
    case '21':
      search('-' + barcode.substring(2, 12))
      return
    case '23':
      notify(renderTranslation(language, TranslationKeys.barcodeNegoziError), true, false)
      return
    case '24':
      notify(renderTranslation(language, TranslationKeys.barcodeClientiError), true, false)
      return
    case '25':
      notify(renderTranslation(language, TranslationKeys.barcodeClientiError), true, false)
      return
    case '26':
      notify(renderTranslation(language, TranslationKeys.barcodeMovimentiError), true, false)
      return
    case '27':
      notify(renderTranslation(language, TranslationKeys.barcodeMovimentiError), true, false)
      return
    case '28':
      if (barcode.charAt(2) === '3' || barcode.charAt(2) === '4') {
        notify(renderTranslation(language, TranslationKeys.barcodeAddettiError), true, false)
        return
      }
      notify(renderTranslation(language, TranslationKeys.barcodeUtentiError), true, false)
      return
    case '29':
      notify(renderTranslation(language, TranslationKeys.barcodeAddettiError), true, false)
      return
    case '30':
      notify(renderTranslation(language, TranslationKeys.barcodeColliError), true, false)
      return
    default:
  }

  if (configuration[BarcodeGrigliaVentilazione] !== BarcodeGrigliaVentilazione_No) {
    const threeChar = barcode.substring(0, 3)
    if (threeChar === '978' && '979') {
      notify(renderTranslation(language, TranslationKeys.barcodeCellaGrigliaError), true, false)
    }
  }
  notify(renderTranslation(language, TranslationKeys.barcodeGenericError), true, false)
}

export const Handle14CharacterBarcode = (barcode, search, notify) => {
  const state = store.getState()
  const configuration = state.present.configuration
  const language = state.present.language.value

  if (configuration[CodicePersonalizzazione] === CodicePersonalizzazione_Fabi) {
    if (barcode.charAt(1) === '%') {
      Handle12CharacterBarcode(barcode.slice(barcode.length - 12), search, notify)
      return
    }
  }
  if (
    configuration[Barcode14Tipo] === Barcode14Tipo_Mav &&
    (barcode.substring(0, 2) === '90' || barcode.charAt(0) === '0') &&
    barcode.slice(barcode.length - 2) === '91'
  ) {
    search(barcode)
    return
  }
  if (configuration[CodicePersonalizzazione] === CodicePersonalizzazione_Scout) {
    notify(renderTranslation(language, TranslationKeys.barcodeBoxError), true, false)
    return
  }
  search(barcode)
}

export const Handle15CharacterBarcode = (barcode, search, notify) => {
  if (barcode.charAt(2) === '%') {
    Handle12CharacterBarcode(barcode.slice(barcode.length - 12), search, notify)
    return
  }
  search(barcode)
}

export const Handle1617CharacterBarcode = (barcode, search, notify) => {
  const state = store.getState()
  const configuration = state.present.configuration
  const language = state.present.language.value

  if (configuration[CodicePersonalizzazione] === CodicePersonalizzazione_Scout) {
    notify(renderTranslation(language, TranslationKeys.barcodeBoxError), true, false)
    return
  }
  search(barcode)
}

export const Handle18CharacterBarcode = (barcode, search, notify) => {
  const state = store.getState()
  const configuration = state.present.configuration
  const language = state.present.language.value

  if (configuration[CodicePersonalizzazione] === CodicePersonalizzazione_Marilli) {
    search(barcode)
    return
  }
  if (configuration[EAN13Atelier98] === EAN13Atelier98_Siepuri) {
    search(barcode, () => notify(renderTranslation(language, TranslationKeys.barcodeBoxError), true, false))
    return
  }
  notify(renderTranslation(language, TranslationKeys.barcodeGenericError), true, false)
}
